import { useLocation, useNavigate } from "react-router-dom";

import { login, useMeCache } from "@/api";

import { LoginScreen, type Credentials } from "./LoginScreen";

/*
 * Microsoft Entra still needs an app registration on K60's side (Axel
 * Pähler) — there is nowhere to send the browser yet. Until then the door
 * offers no Microsoft button at all (Welle 0, S2, 18.10.2026): it stood first
 * and only ever answered „noch nicht angebunden", the morning K60 began to
 * sign in with local accounts. Wiring it is passing `onMicrosoft` again.
 */

interface FromState {
  from?: string;
}

export function LoginRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const meCache = useMeCache();

  async function onCredentials(credentials: Credentials) {
    await login(credentials);
    // Prime the cache with a freshly fetched `/me` — and *await* it — before
    // navigating. `RequireSession` mounts a new observer for `["me"]` the
    // instant `navigate()` below runs, and reads whatever is in the cache on
    // its very first render, synchronously. Anything short of having the
    // real answer sitting there first (an invalidate with no active
    // observer to act on, a fetch merely kicked off but not awaited) leaves
    // that first render looking at the stale "nobody" from before this
    // login, which bounces straight back to /anmelden — see auth.ts.
    await meCache.refresh();
    const state = location.state as FromState | null;
    navigate(state?.from ?? "/", { replace: true });
  }

  return <LoginScreen onCredentials={onCredentials} />;
}
